import React, { useEffect, useState } from "react";
import { useLiveFlightInfoQuery } from "../live-flight-info/graphql/query";
import SlidingBanner from "./components/SlidingBanner";
import TabSection from "./components/TabSection";
import ServiceHighlights from "./components/ServiceHighlights";
import ExploreSection from "./components/ExploreSection";
import HoiApp from "./components/HoiApp";
import BlogsSection from "./components/BlogsSection";
import VideoSlider from "./components/VideoSlider";
import { useHomePageQuery } from "../home-page/graphql/query";

// ROLLBACK: Remove setSearchOpen from props
const HomePage = () => {
  const homePageData = useHomePageQuery();
  const iconsData = useLiveFlightInfoQuery();
  const { arrival_flight_icon, departure_icon } = iconsData || {};
  const [bannerData, setBannerData] = useState(null);
  const [isBannerLoaded, setIsBannerLoaded] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <div>
      {/* ROLLBACK: Remove setSearchOpen prop from SlidingBanner */}
      <SlidingBanner
        data={homePageData?.banner_section}
      />
      <TabSection
        data={homePageData?.tabs_section}
        arrival_flight_icon={arrival_flight_icon}
        departure_icon={departure_icon}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      <ServiceHighlights data={homePageData?.service_highlights} />
      <VideoSlider selectedTab={selectedTab} />
      <ExploreSection data={homePageData?.explore_section} />
      <HoiApp data={homePageData?.hoi_app} />
      <BlogsSection data={homePageData?.blogs_section} />
    </div>
  );
};

export default HomePage;
